module.exports = __webpack_public_path__ + "static/media/tv.bf09a10d.svg";